import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ForecastForReceiptFormState } from '../domains/entities/ForecastForReceiptMenu';
import { UpdateForecastForReceiptAdapter } from '../adapter/updateForecastForReceiptAdapter';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';

/**
 * 受領用内示情報を編集するUseCase
 */
export class updateForecastForReceiptUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * @param repository - 受領用内示情報の永続化の責務を負うクラス
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 受領用内示情報を編集する
   * @param forecastForReceiptIdId - グループID
   * @param updateForecastForReceiptInfo - 新しい受領用内示情報
   */
  public Execute = async (
    forecastForReceiptIdId: string,
    updateForecastForReceiptInfo: ForecastForReceiptFormState
  ): Promise<INetworkResult<void, Error>> => {
    try {
      const request = UpdateForecastForReceiptAdapter.adaptForRequest(updateForecastForReceiptInfo);
      const result = await this.repository.updateForecastForReceipt(forecastForReceiptIdId, request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
